import setSiteMeta from '../base-saving-actions/set-site-meta';

const updateCustomColorPalettes = (palettes) =>
  palettes.map((palette) =>
    setSiteMeta(['customization', 'customColorPalettes', palette.id], palette)
  );

export default updateCustomColorPalettes;
